<template>
    <div class="social_share_btn">
        <div id='rndShareBtn'>
            <!-- fb -->
            <a class='rs_fb' href=' ' onclick="javascript: void(window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(location.href)) ));" title='分享到 FB' target='_blank'>
                <span class='fa-stack fa-lg'>
                    <i class='fa fa-circle fa-stack-2x'></i>
                    <i class='fa fa-facebook fa-stack-1x'></i>
                </span>
            </a>
            <!-- g+ -->
            <!-- <a class='rs_gplus' href=' ' onclick="javascript: void(window.open('https://plus.google.com/share?url='.concat(encodeURIComponent(location.href)), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'));" title='分享到 G+' target='_blank'>
                <span class='fa-stack fa-lg'>
                    <i class='fa fa-circle fa-stack-2x'></i>
                    <i class='fa fa-google-plus fa-stack-1x'></i>
                </span>
            </a> -->
            <!-- line -->
            <!-- <a class='rs_line' href=' ' onclick="javascript: void(window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(document.title)) .concat(' ') .concat(encodeURIComponent(location.href))));" title='分享到 LINE' target='_blank'>
                <span class='fa-stack fa-lg'>
                    <i class='fa fa-circle fa-stack-2x'></i>
                    <i class='fa fa-whatsapp fa-stack-1x'></i>
                </span>
            </a> -->
            <!-- plurk -->
            <a class='rs_plurk' href=' ' onclick="javascript:void(window.open('http://www.plurk.com/?qualifier=shares&status=' .concat(encodeURIComponent(location.href)) .concat(' ') .concat('(') .concat(encodeURIComponent(document.title)) .concat(')')));" title='分享到 PLURK' target='_blank'>
                <span class='fa-stack fa-lg'>
                    <i class='fa fa-circle fa-stack-2x'></i>
                    <i class='fa fa-plurk fa-stack-1x'>P</i>
                </span>
            </a>
            <!-- twitter -->
            <a class='rs_twitter' href=' ' onclick="javascript: void(window.open('http://twitter.com/home/?status='.concat(encodeURIComponent(document.title)) .concat(' ') .concat(encodeURIComponent(location.href))));" title='分享到 TWITTER' target='_blank'>
                <span class='fa-stack fa-lg'>
                    <i class='fa fa-circle fa-stack-2x'></i>
                    <i class='fa fa-twitter fa-stack-1x'></i>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'


export default {
  name: 'Social',
  props: ["id"],
  data () {
    return {
      item: this.book,
      type: this.$root.bookType,
    }
  },
  methods: {
    ...user,
  },
  computed: {
    bookType: function () {
        let keys = Object.keys(this.$root.bookType)
        this.$root.removeItemFromArray(keys,'index')
        this.$root.removeItemFromArray(keys,'novel')
        return keys
    },
    pageKey: function () {
        let keys = Object.keys(this.$root.bookType)
        let locate
        keys.map(key => {
            if (this.$root.bookType[key].id == this.id) locate = key
        })
        return locate
    }
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>



// WEBPACK FOOTER //
// src/Social.vue